import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 3h-3V1h-2v2H8V1H6v2H3v18h18V3zm-2 16H5V8h14v11zM7 10h5v5H7v-5z"
}), 'TodaySharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TodaySharp.js
// module id = 6847
// module chunks = 2